<template>
    <div class="flatPass-container">
        <div class="row align-items-center mx-0 mb-3"><h3 class="text-success mr-3 mb-0">{{$GVO.number_format(objData.price,0,'.',' ')}} ₽</h3> <h4 class="mb-0" v-if="objData.area !='' && objData.area !=null"> / За м² {{$GVO.number_format((objData.price / objData.area),0,'.',' ')}} ₽</h4></div> 
        <div class="flatPass-row objDots" v-if="objData.area!=null"><p>S общая</p><span></span><p>{{objData.area}} м²</p></div>
        <div class="flatPass-row objDots" v-if="objData.kitchenSpace!=null"><p>S кухни</p><span></span><p>{{objData.kitchenSpace}} м²</p></div>
        <div class="flatPass-row objDots" v-if="(objData.floor!=null) || (objData.floors!=null)"><p>Этаж/Этажность</p><span></span><p>{{objData.floor}}  /  {{objData.floors}} </p></div>
        <div class="flatPass-row objDots" v-if="objData.houseCatLivingClassName!=null"><p>Класс</p><span></span><p>{{objData.houseCatLivingClassName}}</p></div>
        <div class="flatPass-row objDots" v-if="objData.creationDate!=null"><p>Выставлено в рекламу</p><span></span><p>{{$GVO.convertDateTimeFromMysql(objData.creationDate)}}</p></div>
        <div class="flatPass-row objDots"><p>Рекламный источник</p><span></span><a :href="objData.url" target="_blank" v-if="objData.url!='' || objData.url!=null">Объект на {{objData.source}}</a></div>
        <div class="collapseRegular mb-4">
            <!-- <collapse style="width: 100%!important;">
                <collapse-item title="Описание объекта" >
                    <div class="objectDescr">
                        <p v-if="objData.description!=null">{{cleanDescription(objData.description)}}</p>
                        <p v-if="objData.description==null">Без описания</p>
                    </div>
                </collapse-item>
            </collapse> -->

            <div class="objectDescr" :class="[isActive ? 'text-truncate' : '']">
                <p v-if="objData.description!=null"><b>Описание объекта:</b> {{cleanDescription(objData.description)}}</p>
                <p v-if="objData.description==null">Без описания</p>
            </div>
            <button class="expandBtn" @click="toggleText()">{{expandText.text}}</button>

        </div>
        <div class="row justify-content-between mx-0">
            <div class="col pl-0">
                <div class="callform">
                    <div class="flatPass-row objDots" v-if="objData.cellId!=null"><p><b> Сота ID {{objData.cellId}}</b> "{{objData.cellName}}"</p></div>
                    <p>Ответственные за прозвон: </p>
                    <div class="mb-2" v-if="masCellAgents!=''">
                        <div class="d-inline-block mr-3 ml-1 service-title marker" v-for="agent in masCellAgents" :key="agent.id">
                            <router-link :to="`/data/staff/id/${agent.id}`" >
                                {{agent.name}}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="classificationStatus col"  v-if="objData.result_name && objData.result_name !='' && showClassification">

                <h4 class="mb-0" v-if="objData.result_name">Текущая классификация: {{objData.result_name}}</h4>

            </div>

        </div>
        <div class="row justify-content-between mx-0 mt-3">
            <p v-if="objData.result_descr!=null"><b>Примечание классификации:</b> {{cleanDescription(objData.result_descr)}}</p>
        </div>
        
    </div>
</template>

<script>
    export default {
        data(){
            return {
                isActive: true,
                expandText: {
                    text: "Показать полностью"
                },
            }
        },
        props: {
            objData: {
                type: Object,
                default(){return {}},
            },
            showClassification:{
                type: Boolean,
                default: true,
            }
        },
        computed:{
            masCellAgents(){
                let arrAgntParsed = [];
                let exists=new Set();
                if(typeof this.objData != 'undefined' && this.objData.agents != '') {
                    const arrAgnt = "[" + this.objData.agents + "]";
                    arrAgntParsed = JSON.parse(arrAgnt).filter(row=>{
                        if(!exists.has(row.id)){
                            exists.add(row.id);
                            return true;
                        }
                        return false;
                    });
                    
                }
                
                return arrAgntParsed;
            }
        },
        methods: {
            toggleText(event) {
                this.isActive = !this.isActive;
                if (this.isActive) {
                    this.expandText.text = "Показать полностью";
                } else this.expandText.text = "Скрыть";
            },
            cleanDescription(descr){
                //console.log(descr);	
                descr = (descr||'').replace(/\u2028/g,' ');
                return descr;
	    	},
        },
    }
</script>

<style lang="scss" scoped>
.flatPass-container {display: flex; flex-direction: column;}
.flatPass-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.flatPass-btn {display: flex; justify-content: space-between; margin-bottom: 10px; /*margin-top: 10px;*/}
.flatPass-btn > button {width: 100%;}

.flatPass-row h3{margin-bottom: 0px;}
.expandBtn {
	background-color: transparent;
	border: none;
	outline: none;
	color: #9e77f3;
	padding-left: 0;
}
.expandBtn:hover {
	color: #01b0e0;
}
.objectDescr {width: 100%; }
.objectDescr p {display: initial;}

</style>